import type { Being, BeingState } from '../../../models/Being';
import type { Surroundings } from '../../../models/Surroundings';
import { AI, DirectionsVectors } from '../../../models/constants';
import { EatingState } from './EatingState';
import type { IBeingState } from './IBeingState';
import { bestDirection } from '../scoring';

export class ExploringState implements IBeingState {
    static readonly stateName = 'Exploring';

    private readonly socialWeight: number;

    /**
     * @param socialWeight - Strength of attraction toward nearby beings while
     *   wandering. Defaults to 0 (no attraction) for Level 1; Level 2+ passes a
     *   positive value so beings drift together and form social clusters.
     */
    constructor({ socialWeight = 0 }: { socialWeight?: number } = {}) {
        this.socialWeight = socialWeight;
    }

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(_being: Being, _surroundings: Surroundings): boolean {
        return true;
    }

    tick(being: Being, surroundings: Surroundings): BeingState {
        if (being.directionTicks <= 0) {
            being.moveDirection = bestDirection(being, surroundings, false, this.socialWeight);
            being.directionTicks = AI.DIRECTION_COMMIT_TICKS;
        } else {
            being.directionTicks--;
        }

        if (being.moveDirection !== null) {
            const vec = DirectionsVectors.get(being.moveDirection)!;
            being.translate(vec.dx, vec.dz);
        }

        if (being.health < AI.HUNGER_THRESHOLD && surroundings.availableFood > 0) {
            return EatingState.stateName;
        }

        return ExploringState.stateName;
    }
}
